import { QueryClient } from 'react-query';
import api from '../config/api'; // benutze deinen Api-Client inkl. BaseURL und Interceptors

// einfache Guard-Variable, um mehrfaches Prefetchen zu verhindern
let hasPrefetchedHome = false;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500 && error?.response?.status !== 429) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // Avoid aggressive re-fetch storms after reload/remount.
      // Stale-time already keeps data reasonably fresh.
      refetchOnMount: false,
      keepPreviousData: true,
    },
    mutations: {
      retry: (failureCount, error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});

// Prefetch-Funktionen für bessere Performance
export const prefetchQueries = {
  // Prefetch häufig verwendete Daten (initiale Seiten).
  async prefetchHomeData() {
    // Guard: nur einmal ausführen
    if (hasPrefetchedHome) return;
    hasPrefetchedHome = true;

    try {
      // New domain: Profiles feed
      await queryClient.prefetchQuery(['profiles', 'infinite', { page: 1, limit: 24 }], async () => {
        const response = await api.get('/api/profiles', { params: { page: 1, limit: 24 } });
        return response.data;
      });
    } catch (e) {
      // Fehler ignorieren, damit UI nicht blockiert
      // Optional: console.error(e);
    }
  },

  // Prefetch User-Daten wenn Token vorhanden
  async prefetchUserData(userId) {
    if (!userId) return;
    await queryClient.prefetchQuery(['user', userId], async () => {
      // In the new domain, user profiles are served from /api/profiles/:id
      const response = await api.get(`/api/profiles/${userId}`);
      return response.data;
    });
  },

  // Prefetch Tags für Autocomplete
  async prefetchTags() {
    await queryClient.prefetchQuery(['all-tags'], async () => {
      const response = await api.get('/api/tags/list', { params: { page: 1, limit: 100, sort: 'popular' } });
      return response.data;
    });
  }
};
